const wowApp = require('angular').module('wowApp.common');
const { listGroupComponentDefinition } = require('./listgroup/list-group.component');

// Service
wowApp.service('ListProductService', [require('./listproducts.service')]).component('wowListGroup', listGroupComponentDefinition);



// WEBPACK FOOTER //
// ./src/common/lists/index.js